import { render, staticRenderFns } from "./TechLink.vue?vue&type=template&id=1d968a57&"
import script from "./TechLink.vue?vue&type=script&lang=ts&"
export * from "./TechLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports